import React from 'react';
import { Widgets } from 'Utils/Widgets/Widgets';
import {
  temperatureWidgetData,
  windWidgetData,
  rainWidgetData,
  batteryVoltageIridiumWidgetData,
  humidityIridiumWidgetData,
  snowDepthIridiumWidgetData,
  atmospherePressureMSLIridiumWidgetData,
  atmospherePressureSTNIridiumWidgetData,
  windRoseChartWidgetIridiumWidgetData,
  windRoseWidgetArrowIridiumWidgetData,
  complexIridiumChart1,
  complexIridiumChart2,
  complexIridiumChart3,
  complexIridiumChart4,
} from './iridiumWidgetData';
import { WidgetCard } from '../Components/WidgetCard';
import { WindRoseChartWrapper } from '../Components/WindRoseChartWrapper';
import MapWidgetWrapper from '../Components/MapWidgetWrapper';
import { WidgetChart } from '../Components/WidgetChart';

export default function IridiumMonitor() {
  return (
    <div style={{
      margin: '.5rem',
      maxWidth: '1000px',
      width: '1000px',
      display: 'grid',
      gridTemplateRows: 'repeat(2,max-content) 1fr',
      gap: '1rem',
      justifySelf: 'center',
    }}
    >
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gridGap: '.5rem', gridTemplateRows: 'max-content' }}>
        <WidgetCard
          widgetData={temperatureWidgetData}
          widgetLayout={Widgets.Temperature}
        />
        <WidgetCard
          widgetData={windWidgetData}
          widgetLayout={Widgets.Wind}
        />
        <WidgetCard
          widgetData={rainWidgetData}
          widgetLayout={Widgets.Rain}
        />
        <WidgetCard
          widgetData={batteryVoltageIridiumWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
        <WidgetCard
          widgetData={humidityIridiumWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gridGap: '.5rem', gridTemplateRows: 'max-content' }}>
        <WidgetCard
          widgetData={snowDepthIridiumWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
        <WidgetCard
          widgetData={atmospherePressureMSLIridiumWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
        <WidgetCard
          widgetData={atmospherePressureSTNIridiumWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', columnGap: '.5rem' }}>
        <WindRoseChartWrapper
          windRoseChartWidgetData={windRoseChartWidgetIridiumWidgetData}
          windRoseWidgetArrowWidgetData={windRoseWidgetArrowIridiumWidgetData}
        />
        <MapWidgetWrapper />
      </div>
      <div style={{
        display: 'grid',
        gridAutoFlow: 'row',
        gridAutoRows: '1fr',
        width: '100%',
      }}
      >
        <WidgetChart
          chartDatasetInfo={complexIridiumChart1}
        />
        <WidgetChart
          chartDatasetInfo={complexIridiumChart2}
        />
        <WidgetChart
          chartDatasetInfo={complexIridiumChart3}
        />
        <WidgetChart
          chartDatasetInfo={complexIridiumChart4}
          isModLinear
        />
      </div>
    </div>
  );
}
